// src/js/modules/favorites.js

import $ from 'jquery';
import localStoreHandler from './localStoreHandler';

function setFavToggleState() {
    $('.js-favtoggle').each(function() {
        // get inRiver entitiy id of product
        const inRiverId = $(this).data('entityid');
        for (let i = 0; i < favHandler.userData.favs.length; i++) {
            if (favHandler.userData.favs[i] === inRiverId) {
                $(this).toggleClass('is-favorite');
            }
        }
    });
}

function setNumberOfFavs() {
    // eslint-disable-next-line no-prototype-builtins
    if (favHandler.userData === null || !favHandler.userData.hasOwnProperty('favs') || favHandler.userData.favs.length === 0) {
        $('.js-favpage .badge').html(0);
    } else {
        $('.js-favpage .badge').html(favHandler.userData.favs.length);
    }
}

function handleFavToggleClicks() {
    $('.js-favtoggle').on('click', function() {
        const inRiverId = $(this).data('entityid');
        let i = 0;
        if ($(this).hasClass('is-favorite')) {
            // remove from favs
            for (i = 0; i < favHandler.userData.favs.length; i++) {
                if (favHandler.userData.favs[i] === inRiverId) {
                    favHandler.userData.favs.splice(i, 1);
                }
            }
            $(this).removeClass('is-favorite');
        } else {
            // add to favs
            let alreadySet = false;
            for (i = 0; i < favHandler.userData.favs.length; i++) {
                if (favHandler.userData.favs[i] === inRiverId) {
                    alreadySet = true;
                }
            }
            if (!alreadySet) {
                favHandler.userData.favs.push(inRiverId);
            }
            $(this).addClass('is-favorite');

            // GA event trigger
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'custom_event',
                    custom_event_data: {
                        event_type: 'Favorites',
                        event_action: 'Product added',
                        value: inRiverId
                    }
                });
            }
        }

        localStoreHandler.set('udata', favHandler.userData);
        setNumberOfFavs();
    });
}

function handleLinksToFavPage() {
    $('a.js-favpage').on('click', function(event) {
        event.preventDefault();
        // create list of favs, add to href url with param
        let linkUrl = $(this).attr('href');
        linkUrl += '?' + 'tx_p2solr_inriver-entities[entityIds]' + '=';
        // eslint-disable-next-line no-prototype-builtins
        if (favHandler.userData !== null && favHandler.userData.hasOwnProperty('favs') && favHandler.userData.favs.length > 0) {
            linkUrl += favHandler.userData.favs.join();
        }
        window.location.href = linkUrl;
    });
}

function clearAllFavs() {
    event.preventDefault();
    // clear cookie
    favHandler.userData.favs = [];
    localStoreHandler.remove('udata');
    // set fav badge to 0
    setNumberOfFavs();

    const favLink = $('a.js-favpage').first();
    // reload without favs
    window.location.href = favLink.attr('href') + '?' + 'tx_p2solr_inriver-entities[entityIds]' + '=';
}

const favHandler = {

    userData: { favs: [] },

    init() {
        // get stored user data
        this.userData = localStoreHandler.get('udata');

        if (this.userData === null) {
            this.userData = { favs: [] };
        } else {
            // eslint-disable-next-line no-prototype-builtins
            if (this.userData.hasOwnProperty('favs') && this.userData.favs.length > 0) {
                setFavToggleState();
                setNumberOfFavs();
            }
        }

        handleFavToggleClicks();
        handleLinksToFavPage();

        $('a.js-favclear').on('click', function(event) {
            clearAllFavs();
        });

        $('.send-favlink').on('click', function() {
            if (typeof dataLayer !== 'undefined') {
                let numFavs = '-';
                if (typeof this.userData === 'object') {
                    // eslint-disable-next-line no-prototype-builtins
                    if (this.userData.hasOwnProperty('favs')) {
                        numFavs = this.userData.favs.length;
                    }
                }
                dataLayer.push({
                    event: 'gaTriggerEvent',
                    gaEventCategory: 'Favorites',
                    gaEventAction: 'Send link',
                    gaEventLabel: numFavs
                });
            }
        });
    },

    setFavToggleState() {
        // eslint-disable-next-line no-prototype-builtins
        if (this.userData === null || !this.userData.hasOwnProperty('favs') || this.userData.favs.length === 0) {
            return;
        }
        setFavToggleState();
    },

    handleFavToggleClicks() {
        handleFavToggleClicks();
    },

    setNumberOfFavs() {
        setNumberOfFavs();
    },

    clearAllFavs() {
        event.preventDefault();
        // clear cookie
        this.userData.favs = [];
        localStoreHandler.remove('udata');
        // set fav badge to 0
        setNumberOfFavs();

        const favLink = $('a.js-favpage').first();
        // reload without favs
        window.location.href = favLink.attr('href') + '?' + 'tx_p2solr_inriver-entities[entityIds]' + '=';
    }
};

export default favHandler;
